import { useContext } from 'react';
import { PublicContext } from '../contexts/PublicContext';
import { publicLinkService } from '../services/publicLinkService';

export const usePublicApi = () => {
  const context = useContext(PublicContext);
  
  if (!context) {
    return null;
  }

  const { token, isPublic } = context;

  const getPublicApi = () => {
    if (!isPublic || !token) {
      return null;
    }

    return {
      get: async (endpoint: string) => {
        const methodMap: { [key: string]: (token: string) => Promise<any> } = {
          '/dashboard/product-distribution': publicLinkService.getPublicProductDistribution,
          '/dashboard/platform-distribution': publicLinkService.getPublicPlatformDistribution,
          '/dashboard/performance-indicators': publicLinkService.getPublicPerformanceIndicators,
          '/dashboard/rebalancing-data': publicLinkService.getPublicRebalancingData,
          '/dashboard/risk-analysis': publicLinkService.getPublicRiskAnalysis,
          '/dashboard/recent-investments': publicLinkService.getPublicRecentInvestments,
          '/dashboard/invested-by-product': publicLinkService.getPublicInvestedByProduct,
          '/dashboard/product-performance': publicLinkService.getPublicProductPerformance,
          '/dashboard/profit-loss': publicLinkService.getPublicProfitLoss,
          '/dashboard/product-evolution': publicLinkService.getPublicProductEvolution,
        };

        const method = methodMap[endpoint];
        if (method) {
          const data = await method(token);
          return { data };
        }

        throw new Error(`Endpoint público não encontrado: ${endpoint}`);
      }
    };
  };

  return getPublicApi();
};
